import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import Signup from "./pages/Signup";
import Dashboard from "./pages/dashboard/Home";
import CreateEvent from "./pages/dashboard/CreateEvent";
import Settings from "./pages/dashboard/Settings";
import Shared from "./pages/Shared";
import VerifyOTP from "./pages/VerifyOTP";
import AllEvents from "./pages/dashboard/AllEvents";
import Event from "./pages/dashboard/Event";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import ProtectedRoute from "./ProtectedRoute";
import TermsAndConditions from "./pages/TermsAndConditions";
import PaymentPolicy from "./pages/PaymentPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Disclaimer from "./pages/Disclaimer";
import Search from "./pages/Search";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import BookDemo from "./pages/BookDemo";
import MyPhotos from "./pages/dashboard/MyPhotos";
import UpdateEvent from "./pages/dashboard/UpdateEvent";
import Payments from "./pages/dashboard/Payments";
import Bin from "./pages/dashboard/Bin";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/pricing/event-plan" element={<Pricing />} />
          <Route path="/faqs" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book-demo" element={<BookDemo />} />
          <Route path="/my-photos" element={<MyPhotos />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/payment-policy" element={<PaymentPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/search" element={<Search />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/all-events"
            element={
              <ProtectedRoute>
                <AllEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-event"
            element={
              <ProtectedRoute>
                <CreateEvent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update-event"
            element={
              <ProtectedRoute>
                <UpdateEvent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <ProtectedRoute>
                <Payments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/event"
            element={
              <ProtectedRoute>
                <Event />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bin"
            element={
              <ProtectedRoute>
                <Bin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shared/:event/:pin?/:quality/:imagetype"
            element={
              <ProtectedRoute>
                <Shared />
              </ProtectedRoute>
            }
          />
        </Routes>
        <ToastContainer
          position="bottom-center"
          autoClose={1000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
